import type { MessageProps } from "@/domains/chat/helpers/messageProps";
import Time from "@/domains/chat/components/chat/messages/parts/Time";

export default function ChatValidationErrorMessage({ message, settings }: MessageProps) {
  const { showTime } = settings;

  return (
    <div className="w-full text-[#edbaba]">
      {showTime && <Time date={message.date} />} {message.message.content}
    </div>
  );
}
